import React from 'react';
import { RadiusDropdownLayout } from '../../RadiusDropdown/RadiusDropdownLayout';
import {RadiusDropdownLayoutProps} from "../../RadiusDropdown/props";
import {definedValue} from "../../../../utils/input";

const LocationRadius = ({options, label, selectedIndex, selectedOption, handleOptionSelect}: RadiusDropdownLayoutProps) => {
  const defaultText = selectedOption || options[selectedIndex];
  let i = options.indexOf(defaultText);
  if (i === -1) {
    i = 0;
  }
  const theIndex = definedValue(selectedIndex, i);
  return (
    <RadiusDropdownLayout
      options={options}
      selectedOption={defaultText}
      selectedIndex={theIndex}
      label={label}
      handleOptionSelect={handleOptionSelect}
    />
  );
};

export default LocationRadius;